import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { FlexAlignStyleBuilder } from '@angular/flex-layout';
import { AuthenticationService } from '../services/authentication.service';
import { MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { ProgressSpinnerDialogComponent } from '../progress-spinner-dialog/progress-spinner-dialog.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetPasswordForm: FormGroup;
  submitted = false;
  dialogRef: MatDialogRef<ProgressSpinnerDialogComponent>;

  constructor(
    private formBuilder: FormBuilder, 
    private authService: AuthenticationService, 
    private route: ActivatedRoute,
    private dialog: MatDialog, 
    private snackBar: MatSnackBar,
    private router: Router) { }

  ngOnInit() {

    const routeParams = this.route.snapshot.paramMap;
    this.resetPasswordForm = this.formBuilder.group({
      email:    new FormControl(routeParams.get('email'), Validators.required),
      password: new FormControl(''                      , Validators.required),
      token:    new FormControl(routeParams.get('token'), Validators.required),

    });
  }

  onResetPassword() {

    this.submitted = true;
    //if (this.resetPasswordForm.invalid) {
    //  return;
   // }

   this.dialogRef = this.dialog.open(ProgressSpinnerDialogComponent, {
      panelClass: 'transparent',
      disableClose: true
    });

    this.authService.resetPasswordToken(this.resetPasswordForm.value).subscribe(result => {
      this.dialogRef.close();
     // this.toggleResetPassword();
      this.snackBar.open('Password successfully changed.', '', {
        duration: 2000,
        panelClass: ['global-snackbar']
      });
      this.router.navigate([`/login`]);
    }, error => {
      this.dialogRef.close();
      this.snackBar.open('Error changing password.', '', {
        duration: 2000,
        panelClass: ['global-error']
      });
    });
  }



}
